// ============================================================
// ByOurConsent.com -- Forgot Password Page
// /forgot-password
// ============================================================

import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Nav    from '../components/Nav';
import Footer from '../components/Footer';
import api    from '../utils/api';

const ForgotPasswordPage = () => {
    const location = useLocation();
    const [email,     setEmail]     = useState(location.state?.email || '');
    const [submitted, setSubmitted] = useState(false);
    const [loading,   setLoading]   = useState(false);
    const [error,     setError]     = useState('');

    const handleSubmit = async () => {
        if (!email.trim()) { setError('Please enter your email address'); return; }
        setLoading(true);
        setError('');
        try {
            await api.post('/auth/forgot', { email });
            setSubmitted(true);
        } catch (err) {
            setError(err.response?.data?.error || 'Failed to send reset email. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Helmet><title>Forgot Password — By Our Consent</title></Helmet>
            <Nav />
            <div style={{ minHeight: '70vh', background: '#f5f0e8', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2rem' }}>
                <div style={{ width: '100%', maxWidth: '420px' }}>
                    <div style={{ background: '#fff', border: '0.5px solid #c8beaa', borderRadius: '4px', padding: '2rem', boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }}>
                        <div style={{ fontSize: '24px', fontWeight: 600, color: '#1e2a3a', fontFamily: "'EB Garamond', Georgia, serif", marginBottom: '8px' }}>
                            Reset your password
                        </div>

                        {submitted ? (
                            <div>
                                <div style={{ background: '#f0f5ee', border: '0.5px solid #8b9a7a', borderRadius: '3px', padding: '12px 14px', marginBottom: '1rem', fontSize: '13px', fontFamily: 'sans-serif', color: '#3b6d11', lineHeight: 1.6 }}>
                                    ✓ If an account exists for <strong>{email}</strong>, you'll receive a password reset link shortly. Check your inbox.
                                </div>
                                <Link to="/login" style={{ fontSize: '13px', fontFamily: 'sans-serif', color: '#8b1a1a', textDecoration: 'none' }}>
                                    ← Back to login
                                </Link>
                            </div>
                        ) : (
                            <div>
                                <div style={{ fontSize: '13px', fontFamily: 'sans-serif', color: '#6a7080', marginBottom: '1.5rem', lineHeight: 1.6 }}>
                                    Enter your email address and we'll send you a link to reset your password.
                                </div>

                                <div style={{ marginBottom: '1rem' }}>
                                    <label style={{ fontSize: '11px', fontFamily: 'sans-serif', color: '#6a7080', letterSpacing: '0.08em', textTransform: 'uppercase', display: 'block', marginBottom: '4px' }}>
                                        Email address
                                    </label>
                                    <input
                                        type="email"
                                        value={email}
                                        onChange={e => setEmail(e.target.value)}
                                        onKeyDown={e => e.key === 'Enter' && handleSubmit()}
                                        placeholder="you@example.com"
                                        style={{ width: '100%', background: '#f5f0e8', border: '0.5px solid #c8beaa', padding: '10px 12px', fontSize: '13px', fontFamily: 'sans-serif', color: '#1e2a3a', borderRadius: '3px', outline: 'none', boxSizing: 'border-box' }}
                                    />
                                </div>

                                {error && (
                                    <div style={{ background: '#fdf0ee', border: '0.5px solid #d4a8a0', borderRadius: '3px', padding: '10px 12px', fontSize: '13px', fontFamily: 'sans-serif', color: '#8b1a1a', marginBottom: '1rem' }}>
                                        {error}
                                    </div>
                                )}

                                <button onClick={handleSubmit} disabled={loading}
                                    style={{ width: '100%', background: '#8b1a1a', color: '#f5f0e8', border: 'none', padding: '11px', fontSize: '13px', fontFamily: 'sans-serif', letterSpacing: '0.06em', textTransform: 'uppercase', borderRadius: '3px', cursor: 'pointer', opacity: loading ? 0.6 : 1 }}>
                                    {loading ? 'Sending...' : 'Send reset link →'}
                                </button>

                                <div style={{ marginTop: '1rem', textAlign: 'center' }}>
                                    <Link to="/login" style={{ fontSize: '12px', fontFamily: 'sans-serif', color: '#8a8070', textDecoration: 'none' }}>
                                        ← Back to login
                                    </Link>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default ForgotPasswordPage;
